import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'lex-add-report-query',
    templateUrl: './add-report-query.component.html',
    styleUrls: ['./add-report-query.component.scss'],
    standalone: false
})
export class AddReportQueryComponent {

	public hasInvalidQueryString: boolean = false;
	public hasDuplicateQueryString: boolean = false;
	public queryString: string = ''
	private existingSearchStrings: string[] = [];

	constructor(
		private dialogRef: MatDialogRef<AddReportQueryComponent>,
		@Inject(MAT_DIALOG_DATA) data) {
		this.existingSearchStrings = data.existingQueryStrings.map((s: string) => s.toLowerCase());
	}

	public ok() {
		const trimmedSearchQueries = this.parseQueryString(this.queryString);
		this.hasInvalidQueryString = trimmedSearchQueries.some(q => q.length > 2000);
		this.hasDuplicateQueryString = this.hasDuplicateQueries(trimmedSearchQueries);

		if (this.hasInvalidQueryString || this.hasDuplicateQueryString)
			return;

		this.dialogRef.close(trimmedSearchQueries);
	}

	private parseQueryString(queryString: string): string[] {
		const searchQueries = queryString.split(/\r?\n/);
		return searchQueries.map(q => q.trim());
	}

	private hasDuplicateQueries(queries: string[]): boolean {
		if (queries.some(s => this.existingSearchStrings.includes(s.toLowerCase())))
			return true;

		let currentQueriesHasDuplicate: boolean = false;
		const knownQueries: string[] = [];
		queries.forEach(q => {
			if (knownQueries.includes(q.toLowerCase())) {
				currentQueriesHasDuplicate = true;
				return true;
			}
			if (q !== '')
				knownQueries.push(q.toLowerCase());
		});

		if (currentQueriesHasDuplicate)
			return true;

		return false;
	}
}
